export default __webpack_public_path__ + "static/wolf_cab_1-3cfb3cc66faba59fa31b2160e5eba007.png";